<template>
  <div class="text-left lg:w-3/6 mx-auto ui form">
    <h2 class="ui header text-center">欢迎来到红豆云</h2>
    <hr>
    <div class="ui teal segment">
      <p>
      请设置一个<strong>数据加密密钥</strong>，来创建属于你自己的安全网盘吧！
      (访问数据时必须输入该密钥进行解密。)
      </p>
      <p class="mt-4">
      该密钥不会保存在红豆云，
      <span class="text-blue-700 font-bold">一旦丢失，所有数据无法找回，请妥善保管。</span>
      </p>
    </div>
    <div class="field my-4">
      <label>请输入密钥</label>
      <div class="ui lg:w-3/6 input">
        <input maxlength="128" name="passphrase" type="password" id="passphrase" v-model="passphrase">
      </div>
    </div>
    <div class="field my-4">
      <label>请再次输入</label> <div class="ui lg:w-3/6 input">
        <input maxlength="128" type="password" id="repeat" name="repeat" v-model="repeat" @keyup.enter="create">
      </div>
    </div>
    <div class="field">
      <div class="ui checkbox">
        <input maxlength="128" id="gen-rec-code" name="gen-rec-code" type="checkbox" v-model="gen_recovery_code" class="hidden">
        <label>
          生成密钥恢复码(密码恢复码可用于重置加密密钥)
        </label>
      </div>
    </div>
    <button class="ui fluid large teal button" @click="create">创建我的网盘</button>
    <div class="text-right mt-4">
      <p>* 有关红豆云数据加密的更多信息，请阅读
        <a href="https://docs.hondcloud.com/%e7%ba%a2%e8%b1%86%e4%ba%91%e5%a6%82%e4%bd%95%e4%bf%9d%e6%8a%a4%e4%bd%a0%e7%9a%84%e6%95%b0%e6%8d%ae%e5%ae%89%e5%85%a8/" target="_blank" class="text-blue-500 font-bold">
          有关数据加密的说明
        </a>
      </p>
    </div>
    <Modal id="recovery-code" hide_cancel="true" @cancel="goto_files" @ok="goto_files">
      <h5 class="ui header">您的恢复码:</h5>
      <div class="ui teal message">
        <div class="p-3">
          <span class="text-4xl">
            {{ this.recovery_code }}
          </span>
        </div>
      </div>
      <p class="ui blue text">
        请自行保存恢复码，本页面关闭后即无法再次查看。
      </p>
    </Modal>
  </div>

</template>

<script>
import Modal from '../components/modal.vue'

export default {
  name: 'WelcomePage',
  props: [],
  components: {
    Modal,
  },
  data: function () {
    return {
      passphrase: "",
      repeat: "",
      gen_recovery_code: true,
      recovery_code: '',
    };
  },
  computed: {
  },
  methods: {
    goto_files() {
      this.hide_modal('recovery-code');
      process.nextTick(() => {
        this.$router.push({ name: 'files' })
      });
    },
    async create() {
      if (this.passphrase.length < 8) {
        this.show_error("请输入8位以上密码");
        return;
      }
      if (this.passphrase != this.repeat) {
        this.show_error("两次输入不一致");
        return;
      }
      this.recovery_code = await this.client.create_space('', this.passphrase, this.gen_recovery_code);
      this.$store.commit('set_default_passphrase', this.passphrase);
      if (this.gen_recovery_code) {
        this.show_modal('recovery-code', false, {
          closable: false,
        });
      } else {
        this.$router.push({ name: 'files' });
      }
    },
  },
  mounted() {
    this.$(".ui.checkbox").checkbox();
    this.client.fetch_spaces().then(spaces => {
      if (spaces.length) {
        this.$router.push({ name: 'files' });
      }
    }).catch(e => {
      console.log(e);
      this.show_error("获取数据失败");
    });
  },
}
</script>

<style scoped>
</style>
